export const GREEN = '#90ed7d'
export const YELLOW = '#ecc600'
export const ORANGE = '#ec8500'
export const RED = '#f70009'

export const DARK_RED = '#e10009'
export const DARK_GREY = '#5b5b5b'

export const BLACK = '#000000'
